import React, { useRef } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ReportChart from './Chart';
import PolicyAnalysis from '../MorningstarRiskProfiler/PolicyAnalysis';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '800px',
      maxWidth: '800px'
    },
    gridBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '1rem',
      border: '1px solid #e5dede'
    },
    chartBox: {
      height: '100%',
      padding: '2rem 0'
    }
  })
);

interface MorningstarRiskToleranceReportChartProps {
  name?: string;
  existingOnly?: boolean;
  ranges?: any;
}

const MorningstarRiskToleranceReportChart = ({
  name,
  ranges,
  existingOnly = false
}: MorningstarRiskToleranceReportChartProps) => {
  const chart = useRef(null);
  const classes = useStyles();

  return (
    <ReportChart
      name={name || 'morningstar_risk_analysis_chart'}
      chartElement={chart.current}
    >
      <Grid item xs={12} sm={8} md={8} lg={8} className={classes.wrapper}>
        <Paper className={classes.gridBox}>
          <Grid item xs={12} className={classes.chartBox}>
            <div ref={chart}>
              <PolicyAnalysis
                existingOnly={existingOnly}
                ranges={ranges}
                markers={[
                  {
                    position: 45,
                    type: 'dotted',
                    label: 'Current Position'
                  },
                  { position: 75, type: 'solid', label: 'High Threshold' }
                ]}
              />
            </div>
          </Grid>
        </Paper>
      </Grid>
    </ReportChart>
  );
};

export default MorningstarRiskToleranceReportChart;
